export function lastWord(value: string) {
    if (!value) return value;
    // var str = value as string;
    var segments = value.split(" ");
    if (segments.length <= 1) return value;
    return segments[segments.length - 1];
}